<template>
  <div>
    <div class="clear"></div>

    <section id="content" style="max-width: 1150px; margin-left: auto; margin-right: auto;">
      <div class="content-wrap">
        <div class="padding-responsive">
          <div class="row" style="padding-bottom: 20px;">
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left;">
              <h3 class="title-font" style="margin-bottom: 0; color:#777;">{{webcat}}</h3> 
            </div>  
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left; ">
              <h3
                style="width: fit-content !important; font-size: 24px; font-family:'supermarket'; color: #bcbcbd; margin-bottom: 0;"
              > </h3>
            </div>
          </div>

<!-- Page Sub Menu ============================================= -->
<!-- <div class="row full-header clearfix " :class="{submenu_fixednav: scrolldown === true}"   > -->
<div class="row small-hide" style="margin-top:10px; margin-bottom:10px;" :class="{submenu_fixednav: scrolldown === true}"   >
  <div id="page-menu" data-mobile-sticky="true">
    <div id="page-menu-wrap">
      <div class="container">
        <div class="page-menu-row">
                      <nav  class="page-menu-nav">
                          <ul class="page-menu-container">
                            
                              <li class="page-menu-item"><a href="#"><div>ประเภท</div></a>
                              
                              <!-- <ul class="page-menu-sub-menu" style="width:350px; padding:20px; margin-left: -20px;" >
                                  <li class="page-menu-item"  style="text-align: left !important; "
                                   >
                                          <div 
                                             v-for="(tex,texnd) in categorylist" :key="texnd"
                                              :class="{choose: checkSelectedMultiple(tex, categorySelected)}"
                                        
                                              class="button button-medium button-border button-rounded nc_size    "
                                              style="font-family:supermarket; font-size: 14px !important; width: 28.33% !important;"
                                              @click="selectMultiple(tex,categorySelected, 'category')" 
                                              
                                            >{{tex}}</div>
                                      </li>
                                </ul> -->
                              
                              </li>
                              <li class="page-menu-item"><a href="#"><div>สี</div></a>
                                <ul class="page-menu-sub-menu" style="width:350px; padding:20px; margin-left: -20px;" >
                                  <li class="page-menu-item"  style="text-align: left !important; "
                                   >
                                          <div 
                                             v-for="(clr,clrind) in colorlist" :key="clrind"
                                              :class="{choose: checkSelectedMultiple(clr, colorSelected)}"
                                        
                                              class="button button-medium button-border button-rounded nc_size    "
                                              style="font-family:supermarket; font-size: 14px !important; width: 28.33% !important;"
                                              @click="selectMultiple(clr,colorSelected, 'color')" 
                                              
                                            >{{clr}}</div>
                                      </li>
                                </ul>
                              </li>
                              <li class="page-menu-item"><a href="#"><div>ขนาด</div></a>
                              
                                <ul class="page-menu-sub-menu" style="width:350px; padding:20px; margin-left: -20px;" >
                                  <li class="page-menu-item"  style="text-align: left !important; "
                                   >
                                          <div 
                                             v-for="(siz,siznd) in sizelist" :key="siznd"
                                              :class="{choose: checkSelectedMultiple(siz, sizeSelected)}"
                                        
                                              class="button button-medium button-border button-rounded nc_size    "
                                              style="font-family:supermarket; font-size: 14px !important; width: 28.33% !important;"
                                              @click="selectMultiple(siz,sizeSelected, 'size')" 
                                              
                                            >{{siz}}</div>
                                      </li>
                                </ul>
                              </li>
                              <li class="page-menu-item"><a href="#"><div>ราคา</div></a>
                                <ul class="page-menu-sub-menu" style="width:350px;  padding:5px; margin-left: -20px;" >
                                  <li class="page-menu-item"  style="text-align: left !important; "
                                   >
                                   <section>
                                        ราคาเช่า : {{this.formatPrice(rangeValue[0])}} ~ {{this.formatPrice(rangeValue[1]) }} บาท
                                        <b-field >
                                        <b-slider :step="step" :min=0 :max=10000 @dragend="changeRangeValue" v-model="rangeValue"></b-slider>
                                        </b-field>

                                    </section>
                                  </li>
                                </ul>
                              
                              </li>
                              <li class="page-menu-item"><a href="#"><div @click="addArrival()" >New Arrivals</div></a></li>
                          </ul>
                      </nav>

                    <!-- <div id="page-menu-trigger"><i class="icon-reorder"></i></div> -->

        </div>
      </div>

    </div>
  </div>
  <!-- #page-menu end -->
</div>


<div class="row small-hide" style=" margin-bottom:10px;" >
        <section>
        <b-field style="margin-left:20px;" >
            <b-taginput 
                v-model="tags"
                ellipsis
                icon="label"
                @remove="rmTag"
                aria-close-label="Delete this tag">
            </b-taginput>
        </b-field>
    </section>
    <div @click="clearFilter()" style="font-size: 0.8rem; cursor:pointer ; margin-left: 20px; line-height: 20px; padding-top:7px;" >ลบทั้งหมด </div>

</div>
          <!-- Shop Item 1
          =============================================-->
          <div class="row main-display ">
            <div
              class="col-lg-3 col-md-6 col-6"
              v-for="(item,ind) in items"
              :key="ind"
              style="padding-bottom: 20px;"
            >
              <div class="product iproduct clearfix imagefocus" style="border: 1px solid #f0f0f0; ">
                <!-- <div img> -->
                <div class="product-image" style="height: 300px; ">
                  <img
                    @click="moveTo(item.productGroupId)"
                    style="width:85%; margin: 10px auto; height:auto; cursor:pointer;"
                    :src="getProductPath(item.mainImage)"
                    alt="Image 1"
                  />
                </div>
                <!-- <div img> -->

                <!-- product-desc center -->
                <div class="product-desc center">
                  <!-- <div class="product-title"><h3><a href="#">{{ item.name }}</a></h3></div> -->
                  <!-- <input type="hidden" name="wproduct" :value="getProductID(item.productGroupId)" />
                  <div v-if="namelen(item.name) > 24" >
                   
                      <VTextMarquee :speed="20" >
                        {{getProductName(item.name)}}
                      </VTextMarquee> 
                  </div>
                  <div v-else>
                    {{getProductName(item.name)}}
                  </div> -->

                  <div>{{limitText(item.name, 22)}}</div>
                  

                  <!-- product-price -->
                  <div class="product-price">
                    <ins>{{ formatPrice(item.rentalPrice) }} บาท</ins>
                  </div>
                  <!-- product-price -->
                </div>
                <!-- product-desc center -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
// import store from "@/store.js";
import axios from "axios";
import store from '@/store';
// import { VTextMarquee } from 'vue-text-marquee';

export default {
  mixins: [myMixins],
  data() {
    return {
      allinfo: null,
      step: 100,
      minPrice : 0,
      maxPrice: 10000,
      rangeValue: [0,10000],
      value1:6000,
      priceRange: [0, 5000],
      numbers: [0, 5000],
      tags: [
          
      ],
      colorSelected: "",
      colorlist: [],
      color_raw: [],
      sizeSelected: "",
      size_raw: [],
      sizelist: [],
      textureSelected: "",
      texturelist: [],
      texture_raw: [],
      categorySelected: "",
      categorylist: [],
      category_raw: [],
      scrolldown : false,
      webcat: "",
      cateEN: "",
      itemInfo: "",
      original: [],
      items: [],
      setPrice : false,
      setNewArrival : false
    };
  },
  async created() {
    this.webcat = decodeURI(this.$route.params.cate);

    this.setCatEN(this.webcat);
     window.addEventListener("scroll", this.handleScroll);

      // axios.post(
      // store.state.apiUrl +  "/web-api/web/all-list"  ,
      //   {},  store.state.apiHeader
      // ).then(res => {
      //   this.texturelist = this.convertToArray(res.data.textures , "description")
      //   this.texture_raw = res.data.textures;
      //   this.colorlist = this.convertToArray(res.data.colors , "description");
      //   this.color_raw = res.data.colors;
      //   this.sizelist = this.convertToArray(res.data.sizes , "code");
      //   this.size_raw = res.data.sizes;
      //   this.categorylist = this.convertToArray(res.data.categorys , "description")
      //   this.category_raw = res.data.category;
        
      //   this.allinfo = res.data;

      // });

      var res =  await axios.post(
                            store.state.apiUrl +  "/web-api/web/all-list"  ,
                              {},  store.state.apiHeader
                            );

      this.allinfo = res.data;

      this.texturelist = this.convertToArray(this.allinfo.textures , "description")
      this.texture_raw = res.data.textures;
      this.colorlist = this.convertToArray(this.allinfo.colors , "description");
      this.color_raw = res.data.colors;
      this.sizelist = this.convertToArray(this.allinfo.sizes , "code");
      this.size_raw = res.data.sizes;
      this.categorylist = this.convertToArray(this.allinfo.categories , "description")
      this.category_raw = res.data.category;


      

  },
    beforeDestroy() {
    // window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("scroll", this.handleScroll);
  },
 
  watch: {
    // rangeValue(value){
    //   console.log('range value >>> ',value);
      
    // },
    tags: {
      handler(){

            var org = this.original;
            // ***** Filter by color
            if(org.length > 0){
              if(this.colorSelected.length > 0)
              {

                 var thelist = [];

                org.forEach(itm => {
                   

                    let color_arr = [];
                    let color_out = [];
                    if(itm.color !== null && itm.color !== undefined && itm.color !== "")
                    {
                        color_arr = itm.color.split("|");
                        color_arr.forEach(c => {
                          var a_color = this.color_raw.filter( x => x.code === c )
                          if(a_color.length > 0)
                            color_out.push(a_color[0].description);
                        });


                          var color_intersect = this.intersect(color_out, this.colorSelected);
                          
                          if(color_intersect.length > 0){
                            thelist.push(itm);
                          }
                    }
                    
                });
                org = thelist;

              } //*** this.colorSelected.length > 0
            }

            // ***** Filter by color

            // ***** Filter by texture
              if(this.textureSelected.length > 0)
              {
                    var the_texture_list = [];
                    org.forEach(itm => {
                            

                            let texture_arr = [];
                            let texture_out = [];
                            if(itm.texture !== null && itm.texture !== undefined && itm.texture !== "")
                            {
                                texture_arr = itm.texture.split("|");
                                texture_arr.forEach(c => {
                                  var a_texture = this.texture_raw.filter( x => x.code === c )
                                  if(a_texture.length > 0)
                                    texture_out.push(a_texture[0].description);
                                });


                                  var texture_intersect = this.intersect(texture_out, this.textureSelected);
                                  
                                  if(texture_intersect.length > 0){
                                    the_texture_list.push(itm);
                                  }
                            }
                            
                        });
                       org =  the_texture_list ;
              }


            // ***** Filter by texture

            // ***** Filter by size
              if(this.sizeSelected.length > 0)
              {
                    var the_size_list = [];
                    org.forEach(itm => {
                            let size_arr = [];
                            let size_out = [];
                            if(itm.size !== null && itm.size !== undefined && itm.size !== "")
                            {
                                size_arr = itm.size.split("|");
                                size_arr.forEach(c => {
                                  var a_size = this.size_raw.filter( x => x.code === c )
                                  if(a_size.length > 0)
                                    size_out.push(a_size[0].description);
                                });


                                  var size_intersect = this.intersect(size_out, this.sizeSelected);
                                  
                                  if(size_intersect.length > 0){
                                    the_size_list.push(itm);
                                  }
                            }
                            
                        });
                       org =  the_size_list ;
              }

            // ***** Filter by size

            // ***** Filter by PRICE

            if(this.setPrice === true)
            { 
               var the_price_list = [];
                    org.forEach(itm => {
                    
                        if(itm.rentalPrice >= this.rangeValue[0] && itm.rentalPrice <= this.rangeValue[1] ){
                          the_price_list.push(itm);
                        }
                    });
                org =   the_price_list;
            }

            // ***** Filter by PRICE

            // ***** Filter by NEW ARRIVAL

            if(this.setNewArrival === true)
            { 
               var the_newarr_list = [];
                    org.forEach(itm => {
                    
                        if(itm.webNewArrival === 'y' ){
                          the_newarr_list.push(itm);
                        }
                    });
                org =   the_newarr_list;
            }
            // ***** Filter by NEW ARRIVAL


            this.items = org;


         
             
        
      },
      deep:true
    },
    async webcat(newvalue) {
      await this.getProducts(newvalue);
    },
    $route(to) {
      this.webcat = to.params.cate;
      this.tags = [this.webcat];
      this.setCatEN(this.webcat);
    }
  },
  async mounted() {
    await this.getProducts(this.webcat);
    this.tags.push(this.webcat);
  },
  methods: {

    namelen(txt)
    {
      if(txt === null || txt === undefined || txt === "" )
      {
        return 0;
      }else{
        return txt.length;
      }

    },
    addArrival(){
      this.tags.push("New Arrival");
      this.setNewArrival = true;
    },
    intersect(arr1, arr2){
      var result = arr1.filter(function(n) {
        return arr2.indexOf(n) > -1;
      });
      return result;
    },
    changeRangeValue(){
      
        // *** ลบราคาเดิมออกจาก tags[] ก่อน
        var rm_ind = [];
        for (let ind = 0; ind < this.tags.length; ind++) {
          const element = this.tags[ind];
          if(element.includes("ราคา:")){
            rm_ind.push(ind)
          }
        }

        for ( let i = this.tags.length - 1 ; i >= 0 ; i--) {
            var isi =  rm_ind.indexOf(i); 
            if(isi > -1)   {
              this.tags.splice(i,1);
            }     
        }
        
        // *** ค่อยใส่ราคาใหม่ tags[] 
        var range = "ราคา: "+ this.formatPrice(this.rangeValue[0]) + " ~ " + this.formatPrice(this.rangeValue[1]) + " บาท"
        this.tags.push(range);
        this.setPrice = true;
    },
    clearFilter(){
      this.colorSelected = "";
      this.sizeSelected = "";
      this.textureSelected = "";
      this.rangeValue = [this.minPrice , this.maxPrice];
      // this.rangeValue[0]  = this.minPrice ;
      // this.rangeValue[1]  = this.maxPrice ;
      this.tags = [this.webcat];
      this.setPrice = false;
      this.setNewArrival = false;


    },
    checkSelectedMultiple(desc, selectedList) {
      if (
        selectedList === "" ||
        selectedList === null ||
        selectedList === undefined
      ) {
        return false;
      }
      var arr = selectedList.split("|");

      return arr.includes(desc);
    },

    addTag(obj){
        this.tags.push(obj);
    },
    rmTag(value){
          var spl = value.split(":");
          var prefix = spl[0];

          
          
          var arr = [];
          var ind = -1;

        // **** ลบ New Arrival ****
        if(value === "New Arrival"){
          this.setNewArrival = false;
        }

        // **** ลบราคา ****

        if(prefix === "ราคา"){
          this.rangeValue[0]  = this.minPrice ;
          this.rangeValue[1]  = this.maxPrice ;
          
           this.setPrice = false;
        }

        // **** ลบประเภท ****

          if(prefix === "ประเภท"){
             arr = this.textureSelected.split("|");
             ind = arr.indexOf(spl[1]);
            if (ind > -1) {
              arr.splice(ind, 1);
              this.textureSelected = arr.join("|");
            }
            
          }


        // **** ลบสี ****

          if(prefix === "สี"){
             arr = this.colorSelected.split("|");
             ind = arr.indexOf(spl[1]);
            if (ind > -1) {
              arr.splice(ind, 1);
              this.colorSelected = arr.join("|");
            }
            
          }
        // **** ลบขนาด ****
          if(prefix === "ขนาด"){
               arr = this.sizeSelected.split("|");
               ind = arr.indexOf(spl[1]);
              if (ind > -1) {
                arr.splice(ind, 1);
                this.sizeSelected = arr.join("|");
              }
            
          }


    
      
    },
    removeTag(obj){
          var ind = this.tags.indexOf(obj);
          if (ind > -1) {
            this.tags.splice(ind, 1);
          }
    },

    selectMultiple(desc , selectedList , listType) {
      // Validate desc
      if (desc === "" || desc === null || desc === undefined) {
        return;
      }

      var addOrRemove = "";
      if (
        selectedList === "" ||
        selectedList === null ||
        selectedList === undefined
      ) {
        selectedList = desc;
        addOrRemove = "add";
      } else {
        var arr = selectedList.split("|");
        if (arr.includes(desc)) {
          var ind = arr.indexOf(desc);
          if (ind > -1) {
            arr.splice(ind, 1);
            selectedList = arr.join("|");
            addOrRemove = "remove";
          }
        } else {
          selectedList =
            selectedList + "|" + desc;
            addOrRemove = "add";
        }
      }


      var obj = "";

      if(listType === "color"){ 
        this.colorSelected = selectedList;
        obj = "สี:" + desc;
        // this.tags.push("สี:" + desc);

      }
      if(listType === "size"){ 
        this.sizeSelected = selectedList;
        // this.tags.push("ขนาด:" + desc);
        obj = "ขนาด:" + desc;
      }
      if(listType === "texture"){ 
        this.textureSelected = selectedList;
        // this.tags.push("ขนาด:" + desc);
        obj = "ประเภท:" + desc;
      }

      if(addOrRemove === "add"){
        this.addTag(obj);
      }

      if(addOrRemove === "remove"){
        this.removeTag(obj);
      }


    },

    selectColor(clr) {
      this.colorSelected = clr;
    },

    handleScroll() {
      this.scrolled = window.scrollY > 0;
      if (window.scrollY > 100) {
        this.scrolldown = true;
      } else {
        this.scrolldown = false;
      }
    },
    setCatEN(wcat) {
      switch (wcat) {
        case "ชุดแต่งงาน":
          this.cateEN = "Short Dress";
          break;
        case "เดรสสั้น":
          this.cateEN = "Long Dress";
          break;
        case "เดรสยาว":
          this.cateEN = "Bridesmaid Dress";
          break;
        // case "พลัสไซส์":
        //   this.cateEN = "Plus Size";
        //   break;
        case "สูท พิธีการ":
          this.cateEN = "Accessories";
          break;
        case "Party":
          this.cateEN = "Shoes";
          break;
       
        default:
          this.cateEN = "ชุดแต่งงาน";
          break;
      }
    },
    async getProducts(wc) {
      var api_url = store.state.apiUrl + "/web-api/web/grouplist" ;

      var response = await axios.post(api_url, {}, store.state.apiHeader);
      var all = response.data;
      

      if (wc === null || wc === undefined || wc === "") {
        this.items = all;
        this.original = all;
      } else {
        var fil = [];
        all.forEach(x => {
          var arr = x.webCategory.split("|");
          if (arr.includes(wc)) {
            fil.push(x);
          }
        });
        this.items = fil;
        this.original = fil;

        
      }



      // axios
      //   .post(api_url, {}, store.state.apiHeader)
      //   .then(response => {
      //     var all = response.data;
      //     if (wc === null || wc === undefined || wc === "") {
      //       this.items = all;
      //       this.original = all;
      //     } else {
      //       var fil = [];
      //       all.forEach(x => {
      //         var arr = x.webCategory.split("|");
      //         if (arr.includes(wc)) {
      //           fil.push(x);
      //         }
      //       });
      //       this.items = fil;
      //       this.original = fil;

      //       // this.items = all.filter(f => f.webCategory === wc);
      //       // this.original = all.filter(f => f.webCategory === wc);
      //     }


        // });
    },

    getLinkItem(productid) {
      return store.state.apiUrl + "/api/catalog/getitem/" + productid;
    },
    getProductID(productid) {
      return productid;
    },
    getProductName(productname) {
      // let txt = this.limitText(productname,24)
      return productname;
    }
  },
  components: {
    // VTextMarquee
    }
};
</script>
 
<style >

.title-font{
  font-size: 2.5rem;
}

.padding-responsive{
  margin-left : 56px ; margin-right : 56px ;
}
.main-display{
  min-height: 300px;
}

.autocomplete{
  display: none;
}
.taginput-container{
  border : 0 solid white !important;
} 
.is-focused{
  border : 0 solid white !important;
} 
.notChoose {
  color: #444;
  background-color: white;
}

.choose {
  color: white !important;
  background-color: #444 !important;
}
.nc_size {
  border: 1px solid #c7c7c7;
  background-color: white;
}
.nc_size {
  border: 1px solid #c7c7c7;
  background-color: white;
}
.c_size {
  border: 1px solid #c7c7c7;
  background-color: #333;
}

.button-medium {
  font-family: "Mitr", "supermarket" !important;
  font-size: 14px !important;
  font-weight: 300 !important;
}



.page-menu-nav{
  float: left !important;
}

.submenu_fixednav {
  position: fixed !important;
  /* margin-top:75px !important; */
  z-index: 999 !important;
  /* background-color: green; */
  /* border-bottom: 1px solid #f5f5f5; */
  margin: 0 auto !important;
  /* width: 100%; */
 top: 75px;
}


.container {
  width: 1200px;
}
.product-desc {
  padding: 0 !important;
}
#page-menu {
  width: 94% !important;
}
#page-menu-wrap{
    background-color: white !important;
    color: #565656 !important;
    text-shadow: none;
    border-top: 1px solid  #e5e5e5 !important;
    border-bottom: 1px solid  #e5e5e5 !important;
    /* margin: 10px auto !important; */
    margin-left: 2%;
    width:100% !important;
}
.page-menu-item a{
  color:  #565656 !important;
   background-color: white !important;
   text-align: left !important;
}
.page-menu-item a:hover{
   background-color: #ddd !important;
}

.button:hover{
  background-color: #e9e9e9 !important;
  color: #565656 !important;
  border: 1px solid black !important;
}

.button:active{
  background-color: black !important;
  color: white !important;
  border: 1px solid black !important;
}

#page-menu ul ul{
  background-color: white !important;
}
.page-menu-sub-menu{
   background-color: white !important;
}

@media only screen and (max-width: 800px) {

  .title-font{
  font-size: 1.9rem;
}

  .product-image {
    height: 170px !important;
  }
  .product,
  .iproduct {
    height: 270px !important;
  }

  .padding-responsive{
  margin-left : 0 ; margin-right : 0 ;
  }

  .product-price{
    font-size: 0.9rem !important;
  }
  .product-desc{
    font-size: 0.9rem !important;
    font-family: "mitr-regular" !important;
    padding-left: 0 !important;
  }
  .product-image {
    height: 170px !important;
  }
  .product,
  .iproduct {
    height: 270px !important;
  }
  .swiper_wrapper {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    height: 270px !important;
  }
  .swiper-slide {
    width: 100% !important;
    height: auto !important;
  }
  #page-menu-wrap{
    background-color: white !important;
  }
  
}
</style>